import { motion } from "framer-motion";
import { gofundmeUrl } from "../i18n";

const EASE = [0.16, 1, 0.3, 1];

export default function Footer({ t, locale, onWaitlist }) {
  return (
    <footer data-testid="footer-section" className="relative overflow-hidden border-t border-black/10 pt-24 md:pt-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-20 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-claim" className="max-w-md font-editorial text-2xl italic text-bone md:text-3xl">
            {t.claim}
          </p>
          <div className="flex items-center gap-8 font-display text-sm font-bold uppercase tracking-widest">
            <button
              data-testid="footer-waitlist-link"
              onClick={onWaitlist}
              className="text-ash transition-colors duration-300 hover:text-flame"
            >
              {t.waitlist}
            </button>
            <a
              data-testid="footer-gofundme-link"
              href={gofundmeUrl(locale)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-ash transition-colors duration-300 hover:text-flame"
            >
              {t.funding}
            </a>
          </div>
        </div>
      </div>

      <motion.h2
        aria-hidden
        initial={{ y: 80, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: EASE }}
        className="text-outline pointer-events-none select-none whitespace-nowrap text-center font-display text-[19vw] font-black uppercase leading-[0.8] tracking-tighter"
      >
        Syncroo
      </motion.h2>

      <div className="border-t border-black/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-8 font-display text-xs uppercase tracking-[0.2em] text-ash/60 sm:flex-row sm:items-center sm:justify-between">
          <span data-testid="footer-domains">{t.domains}</span>
          <span data-testid="footer-made">{t.made}</span>
        </div>
      </div>
    </footer>
  );
}
